module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-view-shift-ba2c24cfff2381974c5d36567ed6eeba.svg";